import a1 from './a1';
import a2 from './a2';
import a4 from './a4';
import a5 from './a5';
import a6 from './a6';
import a7 from './a7';
import a9 from './a9';
import ab from './ab';
import ac from './ac';
import ad from './ad';
import ae from './ae';
import af from './af';
import ag from './ag';
import b1 from './b1';
import b2 from './b2';
import b3 from './b3';
import b4 from './b4';
import b5 from './b5';
import b6 from './b6';
import b7 from './b7';
import ba from './ba';
import bc from './bc';
import c1 from './c1';
import c2 from './c2';
import c4 from './c4';
import d1 from './d1';
import iq from './iq';
import riskNotice from './riskNotice';

export default [
    ...a1,
    ...a2,
    ...a4,
    ...a5,
    ...a6,
    ...a7,
    ...a9,
    ...ab,
    ...ac,
    ...ad,
    ...ae,
    ...af,
    ...ag,
    ...b1,
    ...b2,
    ...b3,
    ...b4,
    ...b5,
    ...b6,
    ...b7,
    ...ba,
    ...bc,
    ...c1,
    ...c2,
    ...c4,
    ...d1,
    ...iq,
    ...riskNotice
];
